import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {SessionActions} from "../../../../shared/actions";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TouchStocktakingService} from "../touch-stocktaking.service";
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Stocktaking} from "../../../../store-management/model/stocktaking";

@Component({
  selector: 'vb-touch-init-medicine-stocktaking',
  templateUrl: './touch-init-medicine-stocktaking.component.html',
  styleUrls: ['./touch-init-medicine-stocktaking.component.css']
})
export class TouchInitMedicineStocktakingComponent extends AbstractVisbosControl<Stocktaking, FormGroup> implements OnInit {

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private tsService: TouchStocktakingService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  buildControlContent(values?: Stocktaking): FormGroup {
    return TouchInitMedicineStocktakingComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormGroup {
    return fb.group({});
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-init-medicine-stocktaking/touch-init-medicine-stocktaking.component.ts